import { getQueryParams } from "utils/url";

export const getSummary = (path) => {
  const params = getQueryParams(path);
  const window = params.window ?? "day";
  return summaryData[window].map(d => applyCosts(d, window));
};

const applyCosts = (d, window) => {
  const grid_import = d.grid_import ? d.grid_import : Math.abs(d.grid);
  const grid_export = d.grid_export ? d.grid_export : Math.abs(d.grid) * -1;
  const cost_import = grid_import * 0.42;
  const cost_export = grid_export * -0.04;
  const cost_net = cost_import + cost_export;
  const price_reference = 0.42;
  const cost_reference = d.house * price_reference;
  const cost_savings = cost_reference - cost_net;
  const days_map = { "day": 1, "week": 7, "month": 16, "year": 278 }
  const optimisation_days = days_map[window]
  return {
    ...d,
    cost_import,
    cost_export,
    cost_net,
    cost_reference,
    cost_savings,
    price_reference,
    optimisation_days,
  };
}

const summaryData = {
  day: [
    {
      timestamp: "2025-03-19T23:59:59+11:00",
      solar_gen: 29.042311944444442,
      evall_import: 3.2,
      hotwater: 1.2,
      grid_export: 17.782809444444446,
      grid_import: 10.848389166666667,
      house: 30.668405555555555,
      battery_export: 22.252984166666664,
      battery_import: 13.692470277777778,
      grid_avoided: 19.820016388888888,
      carbon_use: 14.46861196388889,
      car_use: 244.69156035665293,
      phone_use: 3964.003277777778,
      battery_usage: 7.742874166666667,
      grid_usage: 5.2452575,
      solar_usage: 17.681255555555556,
      peak_grid_imports_avoided: 6.5029675000000005,
    },
  ],
  week: [
    {
      timestamp: "2025-03-23T23:59:59+11:00",
      solar_gen: 161.56687611111113,
      evall_import: 26.0,
      grid_export: 48.38740472222223,
      grid_import: 129.2283338888889,
      house: 233.22407194444446,
      battery_export: 87.44041222222222,
      battery_import: 96.62414555555556,
      grid_avoided: 103.99573805555556,
      carbon_use: 75.91688878055555,
      car_use: 1283.898000685871,
      phone_use: 20799.14761111111,
      battery_usage: 52.6231225,
      grid_usage: 74.61333583333334,
      solar_usage: 105.99904916666667,
      tou_periods: [
        {
          name: "Off_Peak",
          price_index: 0,
          evall_import: 0.0,
          grid_import: 21.059480277777777,
          house: 30.08166138888889,
          grid_export: 0.09250611111111111,
          solar_gen: 0.003053611111111111,
          battery_export: 11.441202777777777,
          battery_import: 2.3295691666666665,
          battery_usage: 11.389926666666666,
          grid_usage: 18.69167722222222,
          solar_usage: 0.0028369444444444445,
          grid_avoided: 9.022181111111113,
        },
        {
          name: "Shoulder",
          price_index: 1,
          evall_import: 0.0,
          grid_import: 96.92149305555556,
          house: 161.38333472222223,
          grid_export: 13.100311388888889,
          solar_gen: 123.70246222222222,
          battery_export: 35.649433055555555,
          battery_import: 81.78974222222222,
          battery_usage: 25.471963055555555,
          grid_usage: 52.85044777777778,
          solar_usage: 83.06731583333334,
          grid_avoided: 64.46184166666667,
        },
        {
          name: "Peak",
          price_index: 2,
          evall_import: 0.0,
          grid_import: 11.247360555555556,
          house: 41.759075833333334,
          grid_export: 35.194587222222225,
          solar_gen: 37.86136027777778,
          battery_export: 40.34977638888889,
          battery_import: 12.504834166666667,
          battery_usage: 15.761232777777778,
          grid_usage: 3.0712108333333332,
          solar_usage: 22.928896388888887,
          grid_avoided: 30.51171527777778,
        },
      ],
      peak_grid_imports_avoided: 30.51171527777778,
    },
  ],
  month: [
    {
      timestamp: "2025-03-31T23:59:59+11:00",
      solar_gen: 715.4889994444444,
      evall_import: 86.0,
      grid_export: 156.45006694444444,
      grid_import: 547.5157372222222,
      house: 1079.3809394444443,
      battery_export: 361.8699794444444,
      battery_import: 389.0437097222222,
      grid_avoided: 531.8652022222223,
      carbon_use: 388.26159762222227,
      car_use: 6566.237064471879,
      phone_use: 106373.04044444443,
      battery_usage: 249.77214888888892,
      grid_usage: 316.0070044444444,
      solar_usage: 513.7287177777778,
      tou_periods: [
        {
          name: "Off_Peak",
          price_index: 0,
          evall_import: 0.0,
          grid_import: 90.8772975,
          house: 113.75185944444445,
          grid_export: 1.193526111111111,
          solar_gen: 0.018319444444444444,
          battery_export: 47.41167055555555,
          battery_import: 23.361901944444444,
          battery_usage: 46.385850833333336,
          grid_usage: 67.37574611111111,
          solar_usage: 0.017069444444444446,
          grid_avoided: 22.87456194444445,
        },
        {
          name: "Shoulder",
          price_index: 1,
          evall_import: 0.0,
          grid_import: 416.43280555555555,
          house: 782.8384286111111,
          grid_export: 53.000796666666666,
          solar_gen: 572.1161930555555,
          battery_export: 166.70727861111112,
          battery_import: 319.41705194444444,
          battery_usage: 134.38091222222224,
          grid_usage: 233.72544277777777,
          solar_usage: 414.7920172222222,
          grid_avoided: 366.40562305555557,
        },
        {
          name: "Peak",
          price_index: 2,
          evall_import: 0.0,
          grid_import: 40.20563416666667,
          house: 182.79065138888888,
          grid_export: 102.25574416666667,
          solar_gen: 143.35448694444443,
          battery_export: 147.75103027777777,
          battery_import: 46.26475583333333,
          battery_usage: 69.00538583333334,
          grid_usage: 14.905815555555556,
          solar_usage: 98.91963111111112,
          grid_avoided: 142.5850172222222,
        },
      ],
      peak_grid_imports_avoided: 142.5850172222222,
    },
  ],
  year: [
    {
      timestamp: "2026-01-01T00:00:00+11:00",
      solar_gen: 2191.6673252777778,
      evall_import: 568.0,
      grid_export: 619.6256119444445,
      grid_import: 1191.005643888889,
      house: 2696.820615,
      battery_export: 1050.205643611111,
      battery_import: 1116.4323475,
      grid_avoided: 1505.814971111111,
      carbon_use: 1099.2449289111112,
      car_use: 18590.308285322353,
      phone_use: 301162.9942222222,
      battery_usage: 660.9283783333333,
      grid_usage: 699.9134288888888,
      solar_usage: 1336.6161055555556,
      tou_periods: [
        {
          name: "Off_Peak",
          price_index: 0,
          evall_import: 0.0,
          grid_import: 202.4099825,
          house: 310.76569805555556,
          grid_export: 45.57116138888889,
          solar_gen: 3.1373994444444446,
          battery_export: 202.87048277777777,
          battery_import: 52.08100527777778,
          battery_usage: 157.67676805555556,
          grid_usage: 150.20283333333333,
          solar_usage: 2.9702527777777776,
          grid_avoided: 108.35571555555555,
        },
        {
          name: "Shoulder",
          price_index: 1,
          evall_import: 0.0,
          grid_import: 889.7433038888889,
          house: 1859.1680927777777,
          grid_export: 250.45516694444444,
          solar_gen: 1748.3302869444444,
          battery_export: 399.57840444444446,
          battery_import: 928.0286972222223,
          battery_usage: 288.1520936111111,
          grid_usage: 516.6415105555556,
          solar_usage: 1054.8482447222223,
          grid_avoided: 969.4247888888888,
        },
        {
          name: "Peak",
          price_index: 2,
          evall_import: 0.0,
          grid_import: 98.8523575,
          house: 526.8868241666667,
          grid_export: 323.5992836111111,
          solar_gen: 440.1996388888889,
          battery_export: 447.7567563888889,
          battery_import: 136.322645,
          battery_usage: 215.09951666666666,
          grid_usage: 33.069085,
          solar_usage: 278.79760805555554,
          grid_avoided: 428.0344666666667,
        },
      ],
      peak_grid_imports_avoided: 428.0344666666667,
    },
  ],
};
